var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.806,
    height: 51.752,
    viewBox: "0 0 71.806 51.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(1051.316 -73.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    d: "M3.3,0H68.51a3.3,3.3,0,0,1,3.3,3.3V42.357A4.508,4.508,0,0,1,67.3,46.865H3.3A3.3,3.3,0,0,1,0,43.57V3.3A3.3,3.3,0,0,1,3.3,0Z",
    transform: "translate(-1051.316 78.827)",
    fill: "#00496d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 71.806,
    height: 46.865,
    rx: 4.955,
    transform: "translate(-1051.316 73.94)",
    fill: "#006aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 13.479,
    height: 4.887,
    transform: "translate(-1033.508 120.805)",
    fill: "#c6a000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M-979.511,90.282h-40.518V73.94h-13.479V90.282h-17.809v14.182h17.809v16.342h13.479V104.463h40.518Z",
    fill: "#fecc00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.5d4456ec.svg";
export { ForwardRef as ReactComponent };